import PropTypes from 'prop-types';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Chicklet({
  children,
  primaryTagSpacing = false
}) {
  return /*#__PURE__*/_jsx(Tile, {
    "data-selenium-test": "chicklet",
    "data-test-id": "chicklet",
    compact: true,
    marginBlockEnd: "300",
    paddingInline: "300",
    paddingBlockEnd: primaryTagSpacing ? '200' : undefined,
    paddingBlock: !primaryTagSpacing ? '200' : undefined,
    children: /*#__PURE__*/_jsx(TileSection, {
      padding: "0",
      children: children
    })
  });
}
Chicklet.propTypes = {
  children: PropTypes.node,
  primaryTagSpacing: PropTypes.bool
};